.datePickerContainer {
  width: 100%;
  height: fit-content;

  > div {
    width: 100%;
  }

  .OpenPickerButton {
    right: 9px;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inputStyle {
    outline: none;
    width: 100%;
    padding: 12px;
    height: 42px;
    border-radius: 10px;
    font-family:
      Galano Grotesque,
      Segoe UI,
      sans-serif;

    input {
      padding: 0;
      font-weight: 500;
    }

    fieldset {
      border: unset !important;
    }
  }

  :global {
    .MuiFormControl-root.MuiTextField-root {
      border-radius: 12px;
    }
    input.MuiInputBase-input::placeholder {
      color: #667885 !important;
      opacity: 1 !important;
    }
    .PrivatePickersFadeTransitionGroup-root {
      max-height: 260px;
      box-sizing: border-box;
    }

    .PrivatePickersSlideTransition-root {
      min-height: 229px !important;
    }

    .MuiCalendarPicker-viewTransitionContainer {
      height: 260px;
    }
  }
}

.calanderWrapper {
  margin-left: 12px;
}

.calendarPopperMiddle {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.calanderContainer {
  height: fit-content;
  border-radius: 24px !important;
  box-shadow: 0px 15px 18px rgba(0, 0, 0, 0.1) !important;
  margin-top: 18px;
  margin-left: 12px;
  font-family:
    "Galano Grotesque",
    Segoe UI,
    sans-serif;

  > div > div {
    width: 379px;

    > div {
      width: 379px;

      div {
        justify-content: space-between;
      }

      > div {
        padding: 0 24px;
      }
    }
  }

  [role="presentation"] {
    padding-left: 9px;
  }

  [role="row"] {
    justify-content: space-between;
    margin: 6px 0;

    &:first-child {
      margin-top: 6px;
    }
  }

  [aria-hidden="true"] {
    width: 30px;
    height: 30px;
  }

  [aria-label="calendar view is open, switch to year view"] {
    display: none;
  }
}
